import store from 'store';
import { SEPARATOR_FORWARD_SLASH } from '../models/common/EntityPart';

/**
 * Gets the useHyphenSeparatorForLocations setting for the currently selected group.
 * @returns {boolean}
 */
export const getUseHyphenSeparator = () => {
    const state = store.getState();
    const groupId = state.user.group?.id;
    if (!groupId) return false;
    const settings = state.user.groupsSettings?.find(
        (x) => x.groupId == groupId
    );
    return settings?.groupSettings?.useHyphenSeparatorForLocations ?? false;
};

/**
 * Maps a single separator character for display.
 * Only standalone "/" is mapped to "-"; "+" and "+/" remain unchanged.
 * @param {string} separator - The separator value (e.g. "/", "+", "+/")
 * @param {boolean} useHyphen - Whether the hyphen setting is enabled
 * @returns {string} The display separator
 */
export const mapHyphenSeparator = (separator) => {
    const useHyphen = getUseHyphenSeparator();
    if (!useHyphen) return separator;
    return separator === SEPARATOR_FORWARD_SLASH ? '-' : separator;
};
